import { css, html, LitElement, nothing } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-header-log-in-btn')
export class MdcHeaderLogInButton extends LitElement {
  @property({ type: String }) label = ''
  @property({ type: Boolean }) opened = false
  @property({ type: String }) icon = ''

  static styles = css`
		:host {
			display: inline-block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-header-log-in-btn {
			display: flex;
			align-items: center;
			gap: 0.5rem;
			padding: 0.75rem 1rem;
			background: none;
			border: 1px solid var(--color-functional-gray-200, #e5e5e5);
			border-radius: 0.5rem;
			cursor: pointer;
			font-size: 0.875rem;
			color: var(--color-functional-gray-black, #111111);
			font-weight: 450;
			line-height: 1.3;
			transition: background-color 0.2s ease, border-color 0.2s ease;
		}

		.mdc-header-log-in-btn:hover {
			background-color: var(--color-functional-gray-25, #fafafa);
			border-color: var(--color-functional-gray-300, #999999);
		}

		.mdc-header-log-in-btn.opened {
			background-color: var(--color-functional-gray-25, #fafafa);
			border-color: var(--color-functional-gray-black, #111111);
		}

		.mdc-header-log-in-btn__icon {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	`

  private handleClick() {
    this.dispatchEvent(
      new CustomEvent('click', {
        detail: {},
        bubbles: true,
        composed: true,
      })
    )
  }

  render() {
    const className = `mdc-header-log-in-btn${this.opened ? ' opened' : ''}`

    return html`
			<button type="button" class=${className} @click=${this.handleClick}>
				${this.label}
				${this.icon ? html`<div class="mdc-header-log-in-btn__icon"><slot name="icon">${this.icon}</slot></div>` : nothing}
			</button>
		`
  }
}
